import { create } from 'zustand';
import axios from 'axios';

// 全局站点配置：会员付费开关（审核期可关闭 → 所有账号免费用全部模块）
const useConfigStore = create((set) => ({
  membershipEnabled: true, // 默认按会员模式，拉取后以服务端为准
  configLoaded: false,

  fetchConfig: async () => {
    try {
      const res = await axios.get('/settings/public');
      if (res.data && res.data.success) {
        set({ membershipEnabled: res.data.membershipEnabled !== false, configLoaded: true });
      } else {
        set({ configLoaded: true });
      }
    } catch (_) {
      set({ configLoaded: true });
    }
  },

  setMembershipEnabled: (v) => set({ membershipEnabled: !!v }),
}));

export default useConfigStore;
